import React, { useEffect, useState } from "react";
import ISRCMappingBox from "./ISCRCMapping";
import TransactionServices from "../TransactionServices";
import MatchingForm from "./MatchingForm";
import Pagination from "components/Common/newPagination";
import ExportOption from "components/Common/exportOption";
import { Filter } from "filter";
import cachingMechanisum from "components/Common/cachingMechanisum";

export default function Matching(subEntity: any) {

    let [showtab, setShowTab] = useState(1);
    let [searchFor, setSearchFor] = useState("");
    let dataLink = "pageSize=10&pageNumber=1";
    let [totalRows, setTotalRows] = useState(0);
    let [showZone, setShowZone] = useState(false);
    let [period, setPeriod] = useState("20260331");
    let [showtabArena, setshowtabArena] = useState(1);
    let [selectIndex, setSelectIndex] = useState(-10);
    let pagination = { pageNumber: 1, pageSize: 10, };
    let [selectedRow, setselectedRow] = useState(-10);
    let [periodList, setPeriodList] = useState<any>([]);
    let [showTransRef, setShowTransRef] = useState(true);
    let [exportOption, setexportOption] = useState(false);
    let [searchField, setSearchField] = useState<any>([]);
    let [showSongCode, setShowSongCode] = useState(false);
    let [showAlbumCode, setShowAlbumCode] = useState(true);
    let [showTrackCode, setShowTrackCode] = useState(true);
    let [showSongTitle, setShowSongTitle] = useState(false);
    let [showInvoiceRef, setShowInvoiceRef] = useState(true);
    let [showFormatCode, setShowFormatCode] = useState(true);
    let extend_pagination = { pageNumber: 1, pageSize: 10, };
    let [showWriterName, setShowWriterName] = useState(false);
    let [showAccountCode, setShowAccountCode] = useState(true);
    let [showSubProvider, setShowSubProvider] = useState(true);
    let [exportOptionType, setexportOptionType] = useState("");
    let [showItemCodeSold, setShowItemCodeSold] = useState(true);
    let [showAnalysisCode, setShowAnalysisCode] = useState(true);
    let [postApprovedtrue, setpostApprovedtrue] = useState(false);
    let [isrcMappingStatus, setISRCMappingStatus] = useState(false);
    let [postApprovedfalse, setpostApprovedfalse] = useState(false);
    let [showCatalogueIsRc, setShowCatalogueIsRc] = useState(true);
    let [showTerritoryCode, setShowTerritoryCode] = useState(true);
    let [showUnTransferred, setShowUnTransferred] = useState(true);
    let [showPublisherName, setShowPublisherName] = useState(false);
    let [salesAnalysisList, setSalesAnalysisList] = useState<any>([]);
    let [showUniqueReference, setShowUniqueReference] = useState(true);
    let [salesAnalysisDetai, setSalesAnalysisDetai] = useState<any>([]);
    let [salesAnalysisSummary, setSalesAnalysisSummary] = useState<any>([]);
    let [showZoneForTerritories, setShowZoneForTerritories] = useState(false);
    let [updateCommitResultsTrue, setupdateCommitResultsTrue] = useState(false);
    let [updateCommitResultsFalse, setupdateCommitResultsFalse] = useState(false);
    let [matchingTerritoriesStatus, setMatchingTerritoriesStatus] = useState(false);



    useEffect(() => {
        //TransactionServices.periodCount({}).then((respond: any) => setPeriodList(respond))
        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod"); 
        setPeriodList(periodListCache);
        
        period = periodListCache?.filter((e: any) => e.periodCurrent == 1)[0].periodDesc
        setPeriod(period)

    }, []);


    const isrcMapping = () => { setISRCMappingStatus(true) };
    const matchingTerritories = () => { setMatchingTerritoriesStatus(true) };
    const updateCommitSystem = () => { TransactionServices.updateAndCommitSystem() };
    const invoicePostApproved = () => { TransactionServices.invoicePostApproved(period, showtabArena == 5 ? 1 : 0) };

    const MatchingTerritoriesClose = () => {
        matchingTerritoriesStatus = false
        setMatchingTerritoriesStatus(matchingTerritoriesStatus)
    };

    const ISRCMappingClose = () => {
        isrcMappingStatus = false
        setISRCMappingStatus(false)
    };

    const currentPage = (e: number) => {
        setShowTab(e);
        totalRows = 0
        setTotalRows(totalRows)
        salesAnalysisList = [];
        setSalesAnalysisList(salesAnalysisList)
        salesAnalysisSummary = [];
        setSalesAnalysisSummary(salesAnalysisSummary)
    };

    const SearchListing = (e: number) => {
        showtabArena = e
        setshowtabArena(showtabArena);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }

        var headerName = showtab === 1 ? "publishingSong" : showtab === 2 ? "publishingWriter" : showtab === 3 ? "digital" :
            showtab === 4 ? "physical" : showtab === 5 ? "costs" :
                showtab === 6 ? "advances" : showtab === 7 ? "licensing" : showtab === 8 ? "adjustments" : ""

        console.log(e)

        if (e === 1) {
            TransactionServices.searchRawInfo(headerName, period, searchField).then((res) => {
                setSalesAnalysisSummary(res)
                totalRows = res.length == 0 ? 0 : res[0].count
                setTotalRows(totalRows)
            })

            TransactionServices.searchRaw(headerName, period, { ...searchField, ...pagination }).then((res) => {
                setSalesAnalysisList(res)
            })
        }

        if (e === 2) {
            TransactionServices.searchActInfo(headerName, period, searchField).then((res) => {
                setSalesAnalysisList(res)
                totalRows = res.length == 0 ? 0 : res[0].count
                setTotalRows(totalRows)
            })

            TransactionServices.searchAct(headerName, period, { ...searchField, ...pagination }).then((res) => {
                setSalesAnalysisList(res)
            })
        }

        if (e === 3) {
            TransactionServices.Publishing(dataLink).then((res) => {
                setSalesAnalysisList(res)
            })
        }

        if (e === 4) {
            TransactionServices.searchRoyaltyInfo(headerName, period, searchField).then((res) => {
                setSalesAnalysisSummary(res)
                totalRows = res.length == 0 ? 0 : res[0].count
                setTotalRows(totalRows)
            })

            TransactionServices.searchRoyalty(headerName, period, { ...searchField, ...pagination }).then((res) => {
                setSalesAnalysisList(res)
            })
        }

        if (e === 5) {
            TransactionServices.searchMechanicalInfo(headerName, period, searchField).then((res) => {
                setSalesAnalysisSummary(res)
                totalRows = res.length == 0 ? 0 : res[0].count
                setTotalRows(totalRows)
            })

            TransactionServices.searchMechanical(headerName, period, { ...searchField, ...pagination }).then((res) => {
                setSalesAnalysisList(res)
            })
        }

    };

    const tab_Name = (tabNumber: any) => {
        var tableName = "Publishing - Song";
        if (tabNumber == 1) { tableName = "Publishing - Song" }
        if (tabNumber == 2) { tableName = "Publishing - Writer" }
        if (tabNumber == 3) { tableName = "Digital" }
        if (tabNumber == 4) { tableName = "Physical" }
        if (tabNumber == 5) { tableName = "Cost" }
        if (tabNumber == 6) { tableName = "Advances" }
        if (tabNumber == 7) { tableName = "Licensing" }
        if (tabNumber == 8) { tableName = "Adjustments" }

        return tableName;
    };

    const ManageUISearchFields = (type: any) => {
        switch (type) {
            case 'Raw':
                showCatalogueIsRc = true;
                showTerritoryCode = true;
                showInvoiceRef = true;
                showAccountCode = true;
                showUniqueReference = true;
                showZone = false;
                showZoneForTerritories = false;
                showAnalysisCode = true;
                showFormatCode = true;
                showAlbumCode = true;
                showItemCodeSold = true;
                showTrackCode = true;
                showSubProvider = true;
                showTransRef = true;
                showSongTitle = false;
                showWriterName = false;
                showPublisherName = false;
                showSongCode = false;
                showUnTransferred = true;
                break;
            case 'Act':
            default:
                showCatalogueIsRc = true;
                showTerritoryCode = true;
                showInvoiceRef = true;
                showAccountCode = true;
                showUniqueReference = true;
                showZone = false;
                showZoneForTerritories = false;
                showAnalysisCode = true;
                showFormatCode = true;
                showAlbumCode = false;
                showItemCodeSold = false;
                showTrackCode = false;
                showSubProvider = true;
                showTransRef = true;
                showSongTitle = false;
                showWriterName = false;
                showPublisherName = false;
                showSongCode = false;
                showUnTransferred = false;
                break;

            case 'Royalty':
                showCatalogueIsRc = true;
                showTerritoryCode = true;
                showInvoiceRef = true;
                showAccountCode = true;
                showUniqueReference = true;
                showZone = false;
                showZoneForTerritories = false;
                showAnalysisCode = true;
                showFormatCode = false;
                showAlbumCode = false;
                showItemCodeSold = false;
                showTrackCode = false;
                showSubProvider = true;
                showTransRef = false;
                showSongTitle = false;
                showWriterName = false;
                showPublisherName = false;
                showSongCode = false;
                showUnTransferred = false;
                break;

            case 'Mechanical':
                showCatalogueIsRc = true;
                showTerritoryCode = false;
                showInvoiceRef = false;
                showAccountCode = false;
                showUniqueReference = true;
                showZone = true;
                showZoneForTerritories = true;
                showAnalysisCode = true;
                showFormatCode = true;
                showAlbumCode = false;
                showItemCodeSold = false;
                showTrackCode = false;
                showSubProvider = false;
                showTransRef = false;
                showSongTitle = false;
                showWriterName = false;
                showPublisherName = false;
                showSongCode = false;
                showUnTransferred = false;
                break;

            case 'RawPub':
                showCatalogueIsRc = false;
                showTerritoryCode = true;
                showInvoiceRef = true;
                showAccountCode = true;
                showUniqueReference = true;
                showZone = false;
                showZoneForTerritories = false;
                showAnalysisCode = true;
                showFormatCode = true;
                showAlbumCode = false;
                showItemCodeSold = true;
                showTrackCode = false;
                showSubProvider = false;
                showTransRef = false;
                showSongTitle = true;
                showWriterName = true;
                showPublisherName = true;
                showSongCode = true;
                showUnTransferred = false;
                break;

            case 'ActPub':
                showCatalogueIsRc = false;
                showTerritoryCode = true;
                showInvoiceRef = true;
                showAccountCode = true;
                showUniqueReference = true;
                showZone = false;
                showZoneForTerritories = false;
                showAnalysisCode = true;
                showFormatCode = true;
                showAlbumCode = false;
                showItemCodeSold = true;
                showTrackCode = false;
                showSubProvider = false;
                showTransRef = false;
                showSongTitle = true;
                showWriterName = true;
                showPublisherName = true;
                showSongCode = true;
                showUnTransferred = false;
                break;

        }

        setShowCatalogueIsRc(showCatalogueIsRc);
        setShowTerritoryCode(showTerritoryCode);
        setShowInvoiceRef(showInvoiceRef);
        setShowAccountCode(showAccountCode);
        setShowUniqueReference(showUniqueReference);
        setShowZone(showZone);
        setShowZoneForTerritories(showZoneForTerritories);
        setShowAnalysisCode(showAnalysisCode);
        setShowFormatCode(showFormatCode);
        setShowAlbumCode(showAlbumCode);
        setShowItemCodeSold(showItemCodeSold);
        setShowTrackCode(showTrackCode);
        setShowSubProvider(showSubProvider);
        setShowTransRef(showTransRef);
        setShowSongTitle(showSongTitle);
        setShowWriterName(showWriterName);
        setShowPublisherName(showPublisherName);
        setShowSongCode(showSongCode);
        setShowUnTransferred(showUnTransferred);
    };

    const searchClear = () => {
        searchField = []
        setSearchField(searchField)
    };

    const handleNameOnChange = (paginationEvent: any) => {
        pagination.pageNumber = paginationEvent.pageNumber;
        pagination.pageSize = paginationEvent.pageSize;
        SearchListing(showtabArena);
    };

    const exportPopupOptions = (type: any) => {
        exportOptionType = type;
        setexportOptionType(exportOptionType)

        exportOption = true;
        setexportOption(exportOption)
    };

    const export_Data = (e: any) => {
        var headerName = showtab === 1 ? "publishingSong" : showtab === 2 ? "publishingWriter" : showtab === 3 ? "digital" :
            showtab === 4 ? "physical" : showtab === 5 ? "costs" :
                showtab === 6 ? "advances" : showtab === 7 ? "licensing" : showtab === 8 ? "adjustments" : ""

        var areaType = showtabArena === 4 ? "royalties" : showtabArena === 5 ? "mechanical" : ""

        if (e == "Summary") {
            TransactionServices.searchSalesAnalysisSummaryExport(headerName, period, areaType, searchField)
        }

        if (e == "All") {
            TransactionServices.searchSalesAnalysisAllExport(headerName, period, areaType, searchField)
        }
    };

    const onChangeExportOption = (e: any) => {
        console.log(e)

        if (e.optSts === 1) {

            var payload = {
                unTransferred: 0, fileFormat: e.fileFormat, numRows: e.numRows, fileName: e.fileName, period: exportOptionType == "period" ? period : ""
            }

            var headerName = showtab === 1 ? "publishingSong" : showtab === 2 ? "publishingWriter" : showtab === 3 ? "digital" :
                showtab === 4 ? "physical" : showtab === 5 ? "costs" :
                    showtab === 6 ? "advances" : showtab === 7 ? "licensing" : showtab === 8 ? "adjustments" : ""


            //showtabArena === 2 Audit</a>
            //showtabArena === 3 Publishing</a> }
            //showtabArena === 4 Royalty</a> }
            //showtabArena === 5 Mechanical</a> }

            if (showtabArena === 1) {
                TransactionServices.searchRawExport(headerName, payload)
            }

            if (showtabArena === 2) {
                TransactionServices.searchActExport(headerName, payload)
            }
        }

        exportOption = false;
        setexportOption(exportOption)
    };

    const ExtendRoyalty = (value: any, index: any) => {

        var payload = {
            itemCodeSold: value?.itemCodeSold, mtchTerritoryCode: value?.mtchTerritoryCode, mtchFormatCode: value?.mtchFormatCode, mtchAnalysisCode: value?.mtchAnalysisCode
        }

        var headerName = showtab === 1 ? "publishingSong" : showtab === 2 ? "publishingWriter" : showtab === 3 ? "digital" :
            showtab === 4 ? "physical" : showtab === 5 ? "costs" :
                showtab === 6 ? "advances" : showtab === 7 ? "licensing" : showtab === 8 ? "adjustments" : ""


        if (selectedRow == index) {
            selectedRow = -10;
            setselectedRow(selectedRow)
        } else if (selectedRow != index) {
            selectedRow = index;
            setselectedRow(selectedRow)

            //showtabArena === 4 -Royalty 
            //showtabArena === 5 -Mechanical

            if (showtabArena == 4) {
                TransactionServices.searchRoyaltyDetail(headerName, period, { payload, ...extend_pagination }).then((respond: any) => {
                    salesAnalysisDetai = respond
                    setSalesAnalysisDetai(salesAnalysisDetai)
                })
            }

            if (showtabArena == 5) {
                TransactionServices.searchMechanicalDetail(headerName, period, { payload, ...extend_pagination }).then((respond: any) => {
                    salesAnalysisDetai = respond
                    setSalesAnalysisDetai(salesAnalysisDetai)
                })
            }

        }
    };

    return (
        <>

            <div className="ws-12">

                <div className="ws-12">

                    <div className="ws-2">
                        <select className="ws-12" value={period ?? ""} onChange={(e: any) => setPeriod(e.target.value)}>
                            <option value="" >Choose a Period</option>
                            {
                                periodList?.map((values: any) => {
                                    return (

                                        <option value={values?.periodDesc} label={Filter?.SimplemonthAndDayYear(values?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(values?.periodTo)}
                                            className={values?.periodOpen == 2 ? 'text-bold purple' : 'text-bold success'} >

                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    <div className="ws-10 mbl">
                        <a id="1" className={showtab === 1 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(1)}>Publishing - Song</a>
                        <a id="2" className={showtab === 2 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(2)}>Publishing - Writer</a>
                        <a id="3" className={showtab === 3 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(3)}>Digital</a>
                        <a id="4" className={showtab === 4 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(4)}>Physical</a>
                        <a id="5" className={showtab === 5 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(5)}>Cost</a>
                        <a id="6" className={showtab === 6 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(6)}>Advances</a>
                        <a id="7" className={showtab === 7 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(7)}>Licensing</a>
                        <a id="8" className={showtab === 8 ? "icon-btn edit fill" : "icon-btn edit height35"} onClick={() => currentPage(8)}>Adjustments</a>
                    </div>

                </div>

                <div className="ws-12">
                    <h2 className="ml">
                        {
                            showtab === 1 ? "Publishing - Song" : showtab === 2 ? "Publishing - Writer" : showtab === 3 ? "Digital" : showtab === 4 ? "Physical" :
                                showtab === 5 ? "Cost" : showtab === 6 ? "Advances" : showtab === 7 ? "Licensing" : showtab === 8 ? "Adjustments" : ""
                        } Arena
                    </h2>
                </div>

                <div className="ws-12">

                    <div className="w-16 p0 box m1 borderRounded">

                        <div className="mt pt ws-12 pll">
                            <span className="text-bold text-l ">Filters</span>
                            <span className="mt pull-right prl danger text-bold" onClick={searchClear}><i className="icon-refresh1 text-m danger pr" />Reset</span>
                        </div>

                        <div className="box-content">

                            {showUniqueReference && <div className="control-group">
                                <label className="control-label  text-m">Unique reference</label>
                                <div className="controls">
                                    <input type="text" placeholder="Unique reference" className="mt mb ws-12 " data-ng-model="search.uniqueReference" id="uniqueReference" value={searchField.uniqueReference ?? ""} onChange={(e: any) => setSearchField({ ...searchField, uniqueReference: e.target.value })} />
                                </div>
                            </div>}

                            {showInvoiceRef && <div className="control-group">
                                <label className="control-label  text-m">Invoice Ref</label>
                                <div className="controls">
                                    <input type="text" placeholder="Invoice Ref" className="mt mb ws-12 " data-ng-model="search.invoiceRef" id="invoiceRef" value={searchField.invoiceRef ?? ""} onChange={(e: any) => setSearchField({ ...searchField, invoiceRef: e.target.value })} />
                                </div>
                            </div>}

                            {showAccountCode && <div className="control-group">
                                <label className="control-label  text-m">Account</label>
                                <div className="controls">
                                    <input type="text" placeholder="Account" className="mt mb ws-12 " data-ng-model="search.accountCode" id="account" value={searchField.accountCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, accountCode: e.target.value })} />
                                </div>
                            </div>}

                            {showItemCodeSold && <div className="control-group">
                                <label className="control-label  text-m">Item Code Sold</label>
                                <div className="controls">
                                    <input type="text" placeholder="Item Code Sold" className="mt mb ws-12 " data-ng-model="search.itemCodeSold" id="itemCodeSold" value={searchField.itemCodeSold ?? ""} onChange={(e: any) => setSearchField({ ...searchField, itemCodeSold: e.target.value })} />
                                </div>
                            </div>}

                            {showTerritoryCode && <div className="control-group">
                                <label className="control-label  text-m">Territory</label>
                                <div className="controls">
                                    <input data-ng-model="search.territoryCode" type="text" className="mt mb ws-12 " placeholder="Territory" id="territory" name="territory" value={searchField.territory ?? ""} onChange={(e: any) => setSearchField({ ...searchField, territory: e.target.value })} />
                                </div>
                            </div>}

                            {showFormatCode && <div className="control-group">
                                <label className="control-label  text-m">Formats/Source Codes</label>
                                <div className="controls">
                                    <input type="text" placeholder="Formats/Source Codes" className="mt mb ws-12 " data-ng-model="search.formatCode" id="formatCode" value={searchField.formatCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, formatCode: e.target.value })} />
                                </div>
                            </div>}

                            {showAnalysisCode && <div className="control-group">
                                <label className="control-label  text-m">Analysis Code</label>
                                <div className="controls">
                                    <input type="text" placeholder="Analysis Code" className="mt mb ws-12 " data-ng-model="search.analysisCode" id="analysisCode" value={searchField.analysisCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, analysisCode: e.target.value })} />
                                </div>
                            </div>}

                            {showAlbumCode && <div className="control-group ">
                                <label className="control-label  text-m">Album Code</label>
                                <div className="controls">
                                    <input type="text" placeholder="Album Code" className="mt mb ws-12 " data-ng-model="search.albumCode" id="albumCode" value={searchField.albumCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, albumCode: e.target.value })} />
                                </div>
                            </div>}

                            {showSubProvider && <div className="control-group ">
                                <label className="control-label  text-m">Sub Provider</label>
                                <div className="controls">
                                    <input type="text" placeholder="Sub Provider" className="mt mb ws-12 " data-ng-model="search.subProvider" id="subProvider" value={searchField.subProvider ?? ""} onChange={(e: any) => setSearchField({ ...searchField, subProvider: e.target.value })} />
                                </div>
                            </div>}

                            {showTrackCode && <div className="control-group ">
                                <label className="control-label  text-m" >Track Code</label>
                                <div className="controls">
                                    <input type="text" placeholder="Track Code" className="mt mb ws-12 " data-ng-model="search.trackCode" id="trackCode" value={searchField.trackCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, trackCode: e.target.value })} />
                                </div>
                            </div>}

                            {showCatalogueIsRc && <div className="control-group ">
                                <label className="control-label  text-m">Catalog/ISRC</label>
                                <div className="controls">
                                    <input data-ng-model="search.catalogueIsRc" type="text" placeholder="Catalog/ISRC" id="CatLogNumber" className="mt mb ws-12 " name="CatLogNumber" value={searchField.CatLogNumber ?? ""} onChange={(e: any) => setSearchField({ ...searchField, CatLogNumber: e.target.value })} />
                                </div>
                            </div>}

                            {showZoneForTerritories && <div className="control-group ">
                                <label className="control-label  text-m">Zone for territories</label>
                                <div className="controls">

                                    <select className="form-control mb mt ws-12 " id="zoneForTerritories" ng-model="search.zoneForTerritories" value={searchField.zoneForTerritories ?? ""} onChange={(e: any) => setSearchField({ ...searchField, zoneForTerritories: e.target.value })} >
                                        <option value="" selected >Please select a zone for territories
                                        </option>

                                    </select>
                                </div>
                            </div>}

                            {showZone && <div className="control-group ">
                                <label className="control-label  text-m">Zone</label>
                                <div className="controls">

                                    <select className="form-control mt mb ws-12 " ng-change="loadTerritoryForZone()" id="Zone" ng-model="search.zone" value={searchField.zone ?? ""} onChange={(e: any) => setSearchField({ ...searchField, zone: e.target.value })} >
                                        <option value="" selected >Please select a zone</option>
                                        <option value="US" ng-repeat="option in zones" >US</option>
                                        <option value="CA" ng-repeat="option in zones" >CA</option>

                                    </select>
                                </div>
                            </div>}

                            {showTransRef && <div className="control-group ">
                                <label className="control-label  text-m" >TransRef</label>
                                <div className="controls">
                                    <input data-ng-model="search.transRef" type="text" placeholder="Trans Ref" className="mt mb ws-12 " id="TransRef" name="TransRef" value={searchField.TransRef ?? ""} onChange={(e: any) => setSearchField({ ...searchField, TransRef: e.target.value })} />
                                </div>
                            </div>}

                            {showSongTitle && <div className="control-group">
                                <label className="control-label  text-m">Song Title</label>
                                <div className="controls">
                                    <input data-ng-model="search.songTitle" type="text" placeholder="Song Title" id="SongTitle" className="mt mb ws-12 " name="SongTitle" value={searchField.SongTitle ?? ""} onChange={(e: any) => setSearchField({ ...searchField, SongTitle: e.target.value })} />
                                </div>
                            </div>}

                            {showWriterName && <div className="control-group">
                                <label className="control-label  text-m">Writer Name</label>
                                <div className="controls">
                                    <input data-ng-model="search.writerName" type="text" placeholder="Writer Name" id="WriterName" className="mt mb ws-12 " name="WriterName" value={searchField.WriterName ?? ""} onChange={(e: any) => setSearchField({ ...searchField, WriterName: e.target.value })} />
                                </div>
                            </div>}

                            {showPublisherName && <div className="control-group">
                                <label className="control-label  text-m">Publisher Name</label>
                                <div className="controls">
                                    <input data-ng-model="search.publisherName" type="text" placeholder="Publisher Name" id="PublisherName" className="mt mb ws-12 " name="PublisherName" value={searchField.PublisherName ?? ""} onChange={(e: any) => setSearchField({ ...searchField, PublisherName: e.target.value })} />
                                </div>
                            </div>}

                            {showSongCode && <div className="control-group">
                                <label className="control-label  text-m">Song Code</label>
                                <div className="controls">
                                    <input data-ng-model="search.songCode" type="text" placeholder="Song Code" className="mt mb ws-12 " id="SongCode" name="SongCode" value={searchField.SongCode ?? ""} onChange={(e: any) => setSearchField({ ...searchField, SongCode: e.target.value })} />
                                </div>
                            </div>}

                            {showUnTransferred && <div className="control-group ws-12 mt ">
                                <label className="ws-8">Non-Transferred</label>
                                <input type="checkbox" data-ng-model="search.unTransferred" data-ng-true-value="1" className="mb ws-2 " data-ng-false-value="0" value={searchField.unTransferred ?? ""} onChange={(e: any) => setSearchField({ ...searchField, unTransferred: e.target.value })} />
                            </div>}
                        </div>

                        <div className="box-footer ws-12 pull-right">
                            <div className="ws-6">
                                <a className="btn icon-btn edit" onClick={() => SearchListing(showtabArena)} title="Search">Search</a>
                            </div>
                            <div className="ws-6 ">
                                <a className="btn icon-btn delete" onClick={searchClear}>Reset</a>
                            </div>
                        </div>
                    </div>

                    <div className="ws-10 box borderRounded pull-right">

                        {postApprovedtrue && <div className="alert alert-ing">Operation queued for processing</div>}
                        {postApprovedfalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}

                        <div className="mtl">
                            <h2 className="ws-3">
                                <span className="text-m">{tab_Name(showtab)} - {totalRows} record(s) found</span>
                            </h2>

                            <div className="ws-9">

                                <a className="icon-btn warning  pull-right text-m" onClick={invoicePostApproved}>Post Approved </a>
                                <button className="btn icon-btn edit pull-right text-m" onClick={updateCommitSystem}>Update and Commit System  </button>
                                <a title="Print Checkings Report" className="icon-btn primary pull-right" target="_blank" href="../../CrystalReport/viewReport.aspx?report=/reports/501.rpt">Print Report   </a>
                                <button className="icon-btn primary pull-right " onClick={() => isrcMapping()}>ISRC Mapping</button>
                                <button className="icon-btn primary pull-right" onClick={() => matchingTerritories()}>Matching</button>

                            </div>
                        </div>

                        <div className="box-content">
                            {updateCommitResultsTrue && <div className="alert alert-info">Operation queued for processing</div>}
                            {updateCommitResultsFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}

                            <div className="ws-12 mt mbl">

                                <a id="1" className={showtabArena === 1 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => { SearchListing(1); ManageUISearchFields("Raw") }}>Raw</a>
                                <a id="2" className={showtabArena === 2 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => { SearchListing(2); ManageUISearchFields("Act") }}>Audit</a>
                                {showtab < 3 && <a id="3" className={showtabArena === 3 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => { SearchListing(3); ManageUISearchFields("RawPub") }}>Publishing</a>}
                                {showtab > 2 && <a id="4" className={showtabArena === 4 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => { SearchListing(4); ManageUISearchFields("Royalty") }}>Royalty</a>}
                                {showtab > 2 && <a id="5" className={showtabArena === 5 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => { SearchListing(5); ManageUISearchFields("Mechanical") }}>Mechanical</a>}
                            </div>

                            <div className="alert alert-info mt hide" >Select a type of fact sales to display </div>
                            {totalRows == 0 && <div className="alert alert-info ">No data to display </div>}

                            {totalRows > 0 && showtabArena < 3 && <div className="ws-12 allowHscroll allowVscroll box borderRounded">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            {
                                                TransactionServices.tableConfig?.find((tabValue: any) => Number(tabValue.tableType) === showtabArena)
                                                    ?.tableHeader?.map((header: string, index: number) => (
                                                        <th key={index} className="forceSingleLine">{header}</th>
                                                    ))
                                            }
                                            <th >Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesAnalysisList?.map((values: any, index: any) => {
                                            return (
                                                <tr onClick={() => setSelectIndex(index)} className={index == selectIndex ? "info pm" : "pm"}>
                                                    <td className="forceSingleLine pm">{values.holdFlag}</td>
                                                    <td className="forceSingleLine">{values.invoiceRef}</td>
                                                    <td className="forceSingleLine">{values.accountCode}</td>
                                                    <td className="forceSingleLine">{values.itemCodeSold}</td>
                                                    <td className="forceSingleLine">{values.mtchTerritoryCode}</td>
                                                    <td className="forceSingleLine">{values.mtchFormatCode}</td>
                                                    <td className="forceSingleLine">{values.mtchAnalysisCode}</td>
                                                    <td className="forceSingleLine">{values.unitsSold}</td>
                                                    <td className="forceSingleLine">{values.monetaryValue}</td>
                                                    <td className="forceSingleLine">{values.invoiceDate}</td>
                                                    <td className="forceSingleLine">{values.albumTitle}</td>
                                                    <td className="forceSingleLine">{values.trackTitle}</td>
                                                    <td className="forceSingleLine">{values.albumArtist}</td>
                                                    <td className="forceSingleLine">{values.trackArtist}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>

                                <div className="ws-12 pm mt">
                                    <div className="ws-3 box pm borderRounded mr border-bottom ">
                                        <strong className="ws-12">Sum monetary value</strong>
                                        <span className="pll"> {salesAnalysisSummary[0]?.sumMonetaryValue} </span>
                                    </div>

                                    <div className="ws-3 box pm borderRounded border-bottom ">
                                        <strong className="ws-12">Total units sold</strong>
                                        <span className="pll"> {salesAnalysisSummary[0]?.totalUnitsSold} </span>
                                    </div>
                                </div>
                            </div>}

                            {totalRows > 0 && showtabArena > 3 && <div className="ws-12 allowHscroll allowVscroll box borderRounded">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>ItemCodeSold</th>
                                            <th>TotalUnits</th>
                                            <th>TotalAmount</th>
                                            <th>MtchTerritoryCode</th>
                                            <th>Formats/Source Codes</th>
                                            <th>MtchAnalysisCode</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            salesAnalysisList?.map((values: any, index: any) => {
                                                return (
                                                    <>

                                                        <tr className="newTable">
                                                            <td>
                                                                <a className="btn btn-xs icon-btn primary" title="Details" onClick={() => ExtendRoyalty(values, index)}>
                                                                    {selectedRow != index && <i className="icon-arrow-down" ></i>}
                                                                    {selectedRow == index && <i className="icon-arrow-up" ></i>}
                                                                </a>
                                                            </td>
                                                            <td>{values?.itemCodeSold}</td>
                                                            <td className="text-right">{values?.totalUnits}</td>
                                                            <td className="text-right">{values?.totalAmount}</td>
                                                            <td>{values?.mtchTerritoryCode}</td>
                                                            <td>{values?.mtchFormatCode}</td>
                                                            <td>{values?.mtchAnalysisCode}</td>
                                                        </tr>

                                                        <>
                                                            {selectedRow == index && <tr ng-show="factSale.isExtended" className="ng-scope ng-hide">
                                                                <td colSpan={7}>
                                                                    <table className="newTable">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="forceSingleLine">TransID</th>
                                                                                <th className="forceSingleLine">UniqueID</th>
                                                                                <th className="forceSingleLine">ItemCodeSold</th>
                                                                                <th className="forceSingleLine">Units Sold</th>
                                                                                <th className="forceSingleLine">Monetary Value</th>
                                                                                <th className="forceSingleLine">MtchTerritoryCode</th>
                                                                                <th className="forceSingleLine">Formats/Source Codes</th>
                                                                                <th className="forceSingleLine">MtchAnalysisCode</th>
                                                                                <th className="forceSingleLine">Dealer Price</th>
                                                                                <th className="forceSingleLine">Retail Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {
                                                                                salesAnalysisDetai?.map((detailValue: any) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <td>{detailValue?.transId}</td>
                                                                                            <td>{detailValue?.uniqueId}</td>
                                                                                            <td>{detailValue?.itemCodeSold}</td>
                                                                                            <td>{detailValue?.unitsSold}</td>
                                                                                            <td>{detailValue?.monetaryValue}</td>
                                                                                            <td>{detailValue?.mtchTerritoryCode}</td>
                                                                                            <td>{detailValue?.mtchFormatCode}</td>
                                                                                            <td>{detailValue?.mtchAnalysisCode}</td>
                                                                                            <td>{detailValue?.dealerPrice}</td>
                                                                                            <td>{detailValue?.retailPrice}</td>
                                                                                        </tr>)
                                                                                })
                                                                            }

                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>}
                                                        </>
                                                    </>
                                                )
                                            })
                                        }

                                    </tbody>
                                </table>

                            </div>}

                            {totalRows > 0 && <div className=" mt ws-12">

                                {showtabArena < 3 && <div className="hover-box verticalMediumWide mts pull-left overflowVisible">
                                    <a className="icon-btn edit"><i className="icon-download1"></i>
                                        <div className="label label-danger pull-right  m0 p0 ml hide" data-ng-show="false">might take a while</div>
                                    </a>

                                    <div className="hover-block borderRounded">
                                        <button className="btn icon-btn edit btn-xxs pull-left mt forceSingleLine ps" onClick={() => exportPopupOptions('period')}>Export for a  specific period</button>
                                        <button className="btn icon-btn edit btn-xxs pull-left mt forceSingleLine ps" onClick={() => exportPopupOptions('')}>Export for all  periods</button>
                                    </div>
                                </div>}


                                {showtabArena > 3 && <div className="hover-box verticalMediumWide mts pull-left overflowVisible">
                                    <a className="icon-btn edit"><i className="icon-download1"></i>
                                        <div className="label label-danger pull-right  m0 p0 ml hide" data-ng-show="false">might take a while</div>
                                    </a>

                                    <div className="hover-block borderRounded">
                                        <button className="btn icon-btn edit btn-xxs pull-left mt forceSingleLine ps" onClick={() => export_Data('Summary')}>Summary</button>
                                        <button className="btn icon-btn edit btn-xxs pull-left mt forceSingleLine ps" onClick={() => export_Data('All')}>All</button>
                                    </div>
                                </div>}

                                <div className="clearfix pull-right">

                                </div>
                            </div>}

                            {(() => {
                                if (totalRows && totalRows > 10) {
                                    return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                                }
                            })()}


                            {selectIndex != -10 && <div className="mt ws-12 allowHscroll allowVscroll box borderRounded">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th className="forceSingleLine">Unique ID</th>
                                            <th className="forceSingleLine">Album Code1</th>
                                            <th className="forceSingleLine">Album Code2</th>
                                            <th className="forceSingleLine">Track Code1</th>
                                            <th className="forceSingleLine">Track Code2</th>
                                            <th className="forceSingleLine">Dealer Price</th>
                                            <th className="forceSingleLine">Retail Price</th>
                                            <th className="forceSingleLine">Sub Provider</th>
                                            <th className="forceSingleLine">Sub Content</th>
                                            <th className="forceSingleLine">Sub Formats/Source Codes</th>
                                            <th className="forceSingleLine">Reported Item</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesAnalysisList?.map((values: any, index: any) => {

                                            if (index == selectIndex) {

                                                return (
                                                    <tr onClick={() => setSelectIndex(index)} className="pm">
                                                        <td >{values.uniqueID}</td>
                                                        <td >{values.songCode1}</td>
                                                        <td >{values.songCode2}</td>
                                                        <td >{values.songCode3}</td>
                                                        <td >{values.songCode4}</td>
                                                        <td >{values.hFACode}</td>
                                                        <td >{values.iSWC}</td>
                                                        <td className="text-right">{values.dealerPrice}</td>
                                                        <td className="text-right">{values.retailPrice}</td>
                                                        <td>{values.lineDescription}</td>
                                                        <td>{values.repItemCodeSold}</td>

                                                    </tr>
                                                )
                                            }
                                        })}
                                    </tbody>
                                </table>

                            </div>}
                        </div >


                    </div >

                </div >

            </div >
            {
                (() => {
                    if (matchingTerritoriesStatus) {
                        return <MatchingForm param={matchingTerritoriesStatus} MatchingTerritoriesClose={MatchingTerritoriesClose} />
                    }

                    if (isrcMappingStatus) {
                        return <ISRCMappingBox param={isrcMappingStatus} ISRCMappingClose={ISRCMappingClose} />
                    }

                    if (exportOption) {
                        return <ExportOption exportOption={exportOption} onChange={onChangeExportOption} fileName="Digital_FactSales_Raw" />
                    }
                })()
            }
        </>
    );
}